import {
    faFilterCircleXmark,
    faDisplayChartUpCircleDollar,
    faTextSize,
    faFileChartPie,
    faSlider,
    faChartSimple,
    faChartCandlestick,
    faChartBar,
    faChartScatter,
    faWave,
    faDna,
    faWaveSine,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus,
    faSliders,
    faCabinetFiling,
    faBuildingColumns,
    faGridRound4,
    faMaximize,
    faMinimize,
    faRetweet,
    faBookSection,
    faSackDollar,
    faLightbulbDollar,
    faUserLock,
    faTableColumns,
    faTableRows,
    faLineColumns,
    faHouseBuilding,
    faPercentage,
    faSplit,
    faListCheck,
    faChartLineUpDown,
    faFaceAnxiousSweat,
    faCoinVertical,
    faCoins,
    faPaperPlane,
    faKey,
    faLightbulb,
    faRobot,
    faUserKey,
    faUserSlash,
    faHourglassEnd
} from '@fortawesome/pro-light-svg-icons';
import {Icon} from '@xh/hoist/icon';

// App icons beyond Hoist's built-in set, registered so IconPicker and Icon.get() know them.
// Bootstrap imports this module so registration runs before the app renders.
// Glyphs Hoist already ships are used through its own factories, e.g. Icon.chartLine() or Icon.treeGraph().
export const filterCircleXmarkIcon = Icon.register({name: 'filterCircleXmark', defs: faFilterCircleXmark});
export const displayChartUpCircleDollarIcon = Icon.register({name: 'displayChartUpCircleDollar', defs: faDisplayChartUpCircleDollar});
export const textSizeIcon = Icon.register({name: 'textSize', defs: faTextSize});
export const fileChartPieIcon = Icon.register({name: 'fileChartPie', defs: faFileChartPie});
export const sliderIcon = Icon.register({name: 'slider', defs: faSlider});
export const chartSimpleIcon = Icon.register({name: 'chartSimple', defs: faChartSimple});
export const chartCandlestickIcon = Icon.register({name: 'chartCandlestick', defs: faChartCandlestick});
export const chartBarHorizontalIcon = Icon.register({name: 'chartBarHorizontal', defs: faChartBar});
export const chartScatterIcon = Icon.register({name: 'chartScatter', defs: faChartScatter});
export const waveIcon = Icon.register({name: 'wave', defs: faWave});
export const dnaIcon = Icon.register({name: 'dna', defs: faDna});
export const waveSineIcon = Icon.register({name: 'waveSine', defs: faWaveSine});
export const magnifyingGlassPlusIcon = Icon.register({name: 'magnifyingGlassPlus', defs: faMagnifyingGlassPlus});
export const magnifyingGlassMinusIcon = Icon.register({name: 'magnifyingGlassMinus', defs: faMagnifyingGlassMinus});
export const slidersIcon = Icon.register({name: 'sliders', defs: faSliders});
export const cabinetFilingIcon = Icon.register({name: 'cabinetFiling', defs: faCabinetFiling});
export const buildingColumnsIcon = Icon.register({name: 'buildingColumns', defs: faBuildingColumns});
export const gridRound4Icon = Icon.register({name: 'gridRound4', defs: faGridRound4});
export const maximizeIcon = Icon.register({name: 'maximize', defs: faMaximize});
export const minimizeIcon = Icon.register({name: 'minimize', defs: faMinimize});
export const retweetIcon = Icon.register({name: 'retweet', defs: faRetweet});
export const bookSectionIcon = Icon.register({name: 'bookSection', defs: faBookSection});
export const sackDollarIcon = Icon.register({name: 'sackDollar', defs: faSackDollar});
export const lightbulbDollarIcon = Icon.register({name: 'lightbulbDollar', defs: faLightbulbDollar});
export const userLockIcon = Icon.register({name: 'userLock', defs: faUserLock});
export const tableColumnsIcon = Icon.register({name: 'tableColumns', defs: faTableColumns});
export const tableRowsIcon = Icon.register({name: 'tableRows', defs: faTableRows});
export const lineColumnsIcon = Icon.register({name: 'lineColumns', defs: faLineColumns});
export const houseBuildingIcon = Icon.register({name: 'houseBuilding', defs: faHouseBuilding});
export const percentageIcon = Icon.register({name: 'percentage', defs: faPercentage});
export const splitIcon = Icon.register({name: 'split', defs: faSplit});
export const listCheckIcon = Icon.register({name: 'listCheck', defs: faListCheck});
export const chartLineUpDownIcon = Icon.register({name: 'chartLineUpDown', defs: faChartLineUpDown});
export const faceAnxiousSweatIcon = Icon.register({name: 'faceAnxiousSweat', defs: faFaceAnxiousSweat});
export const coinVerticalIcon = Icon.register({name: 'coinVertical', defs: faCoinVertical});
export const coinsIcon = Icon.register({name: 'coins', defs: faCoins});
export const paperPlaneIcon = Icon.register({name: 'paperPlane', defs: faPaperPlane});
export const keyIcon = Icon.register({name: 'key', defs: faKey});
export const lightbulbIcon = Icon.register({name: 'lightbulb', defs: faLightbulb});
export const robotIcon = Icon.register({name: 'robot', defs: faRobot});
export const userKeyIcon = Icon.register({name: 'userKey', defs: faUserKey});
export const userSlashIcon = Icon.register({name: 'userSlash', defs: faUserSlash});
export const hourglassEndIcon = Icon.register({name: 'hourglassEnd', defs: faHourglassEnd});
